import axiosWrapper from '@/utils/request'

const loadTransactionsAdvances = (accountId, page = 1, limit = 10) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/advances`,
    params: {
      serializer: 'Business::AdvanceListSerializer',
      page,
      limit
    }
  })
}

const loadTransactionsPayments = (accountId, page = 1, limit = 10) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/payments`,
    params: {
      serializer: 'Business::PaymentListSerializer',
      page,
      limit
    }
  })
}

const loadTransactionsSettlements = (accountId, page = 1, limit = 10) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/settlements`,
    params: {
      serializer: 'Business::InvoiceListSerializer',
      page,
      limit
    },
    timeout: 120000
  })
}

const fetchTransactionsConversionRates = (userId, data) => {
  return axiosWrapper({
    method: 'POST',
    url: `/v1/drip_switch/transactions/${userId}`,
    data
  })
}

export default {
  loadTransactionsAdvances,
  loadTransactionsPayments,
  loadTransactionsSettlements,
  fetchTransactionsConversionRates
}
